import React from 'react';
import { observer } from 'mobx-react';
import { Icon } from 'ksnm-common-ui/lib/Icon';
import { Tooltip } from 'ksnm-common-ui/lib/Tooltip';

import { Row } from '@common/Row';
import { dataControlStore } from '@stores/dataControlStore';

import { GoPreparationOfReportsButton } from '../../GoPreparationOfReportsButton';

import styles from './Title.module.scss';

interface ITitle {
  data: {
    report_package_code_cm?: string;
    status?: string;
    status_out?: string;
    ctrl_vers?: string;
    ctrl_vers_ext?: string;
    step_code_ext?: string;
    formula?: string;
    step_name?: string;
    step_desc?: string;
    ctrl_vers_desc?: string;
    ctrl_name?: string;
    kscode_fns?: string;
    date_user_period_kp?: string;
  };
}

export const Title = observer(({ data }: ITitle) => {
  const { setInfoDrawer } = dataControlStore;

  return (
    <>
      <p className={styles.title}>Контроли: уровень шага</p>

      <div className={styles.info}>
        <div className={styles.column}>
          <Row
            name="Код пакета:"
            value={
              <div className={styles.package}>
                {data.report_package_code_cm} <Icon name="info" />{' '}
                <GoPreparationOfReportsButton packageCode={data.report_package_code_cm} />
              </div>
            }
            onClick={() =>
              setInfoDrawer({
                packageCode: data.report_package_code_cm,
                controlDescription: data.ctrl_vers_desc,
                step: data.status ? (data.step_code_ext ? `${data.step_code_ext}` : '') : '',
                stepName: data.step_name,
                stepDescription: data.step_desc,
                control: data.ctrl_vers ? data.ctrl_vers + (data.ctrl_vers_ext ? ` - ${data.ctrl_vers_ext}` : '') : '',
                ctrlName: data.ctrl_name,
                formula: data.formula,
                ksCodeFns: data.kscode_fns,
              })
            }
            nameWidth={222}
          />
          <Row
            name="Контроль:"
            value={data.ctrl_vers ? data.ctrl_vers + (data.ctrl_vers_ext ? ` - ${data.ctrl_vers_ext}` : '') : ''}
            nameWidth={222}
          />
          <Row
            name="Номер шага:"
            value={data.status ? (data.step_code_ext ? `${data.step_code_ext}` : '') : ''}
            nameWidth={222}
          />
          {data.kscode_fns && <Row name="Код контроля (ФНС):" value={data.kscode_fns} nameWidth={222} />}
          <Row name="Статус прохождения контроля:" value={data.status_out} nameWidth={222} />
          <Row name="Номер прогона КП:" value={data.date_user_period_kp} nameWidth={222} />
        </div>

        <div className={styles.largeColumn}>
          <Row
            name="Наименование контроля:"
            value={
              <Tooltip content={data.ctrl_vers_desc} maxWidth={650} hideOnClick={false}>
                <span>{data.ctrl_name || '------------------'}</span>
              </Tooltip>
            }
            nameWidth={185}
          />

          <Row
            name="Наименование шага:"
            className={styles.margin}
            value={
              <Tooltip content={data.step_desc} maxWidth={650} hideOnClick={false}>
                <span>{data.step_name || '------------------'}</span>
              </Tooltip>
            }
            nameWidth={185}
          />
        </div>
      </div>
    </>
  );
});
